window.pessoaTipo = function ()
{
    var tipo = $('#pessoa_tipo_id').val();
    var tipos = {
        1: 'CNPJ',
        2: 'CPF',
        3: 'Documento',
        4: 'Documento'
    };

    $('#nDoc').attr('placeholder', tipos[tipo]);
    $('#nDocContainer').show('fast');

    if(tipo == 1) {
        $('#ieContainer').show('fast');
        $('#imContainer').show('fast');
        $('#nascimentoContainer').hide('fast');
    } else {
        $('#ieContainer').hide('fast');
        $('#imContainer').hide('fast');
        $('#nascimentoContainer').show('fast');
    }

    if(tipo == 2) {
        $('#rgContainer').show('fast');
    } else {
        $('#rgContainer').hide('fast');
    }
};

window.validaDoc = function ()
{
    var tipo = $('#pessoa_tipo_id').val();
    var nDoc = $('#nDoc').val();

    if(nDoc.length == 0) {
        return false;
    }

    if(tipo == 1 && !validaCNPJ(nDoc)) {
        alert('CNPJ inválido');
        $('#nDoc').focus();
    }

    if(tipo == 2 && !validaCPF(nDoc)) {
        alert('CPF inválido');
        $('#nDoc').focus();
    }
};

window.validaCPF = function (cpf)
{
    cpf = cpf.replace(/\D/g, '');
    if(cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    var result = true;
    [9,10].forEach(function(j){
        var soma = 0, r;
        cpf.split(/(?=)/).splice(0,j).forEach(function(e, i){
            soma += parseInt(e) * ((j+2)-(i+1));
        });
        r = soma % 11;
        r = (r <2)?0:11-r;
        if(r != cpf.substring(j, j+1)) result = false;
    });
    return result;
};
